var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_302056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 431.9C166.8 416.7 142.1 416.7 127 431.9L58.8 500H0V0H293.3C286.5 14.4 289.1 32.1 301 44L500 243V359L358.9 500H250.1L182 431.9Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.3 185.4C329.4 194.5 95.3999 232.9 76.7999 294C75.2999 299.5 76.0999 305.4 78.1999 310.6C85.5999 327.6 105.7 333.7 122.6 337.3C134.8 339.7 147.4 340.8 159.9 341.3C210.3 342.5 261.2 335.5 310.4 324.7C316.9 323.4 319.2 332.9 312.6 334.5C261.8 345.3 96.0999 371.5 71.8999 313.1C62.9999 290.9 78.8999 273.6 96.0999 262C117.7 247.6 142 238.5 166.3 230.3C190.6 222.3 215.3 215.7 240.2 209.9C290 198.4 340.2 189.5 390.8 182.7C391.5 182.6 392.2 183.1 392.3 183.8C392.5 184.6 392 185.3 391.3 185.4Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 404.3C345.38 404.3 422.7 394.898 422.7 383.3C422.7 371.702 345.38 362.3 250 362.3C154.62 362.3 77.3 371.702 77.3 383.3C77.3 394.898 154.62 404.3 250 404.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.4 326.6C139.8 326.6 121.3 308.1 121.3 285.5V153.9C121.3 152 122.8 150.5 124.7 150.5H200.1C202 150.5 203.5 152 203.5 153.9V285.5C203.5 308.1 185 326.6 162.4 326.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4 307.3H155.4V370.7H169.4V307.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4 389.5C184.215 389.5 201.9 384.083 201.9 377.4C201.9 370.717 184.215 365.3 162.4 365.3C140.585 365.3 122.9 370.717 122.9 377.4C122.9 384.083 140.585 389.5 162.4 389.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4 319.6C142.7 319.6 126.5 303.4 126.5 283.7V233.9C126.5 232.7 127.5 231.6 128.8 231.6H196C197.2 231.6 198.3 232.6 198.3 233.9V283.7C198.3 303.4 182.1 319.6 162.4 319.6Z",
    fill: "#3862F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6 255.2H186.1C183.9 255.2 182.2 253.4 182.2 251.3V166.6C182.2 164.4 184 162.7 186.1 162.7H187.6C189.8 162.7 191.5 164.5 191.5 166.6V251.3C191.5 253.4 189.7 255.2 187.6 255.2Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.9 112.2L144 300.4C144.2 304.1 146.8 304.1 149.4 303.6C151.9 303.1 153.4 302.4 153.3 298.7L145.2 110.5C145 106.8 143.1 107.4 140.5 107.9C137.9 108.4 135.7 108.5 135.9 112.2Z",
    fill: "#292A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 287.2C146.2 290.8 149.5 293.3 153 294.4L152.6 285.3C148.8 283.7 145.5 280 142.9 274.9L143.4 287.2Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2 258.6C145 262.2 148.3 264.7 151.8 265.8L151.4 256.7C147.6 255.1 144.3 251.4 141.7 246.3L142.2 258.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 230.1C143.8 233.7 147.1 236.2 150.6 237.3L150.2 228.2C146.4 226.6 143.1 222.9 140.5 217.8L141 230.1Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 201.6C142.6 205.2 145.9 207.7 149.4 208.8L149 199.7C145.2 198.1 141.9 194.4 139.3 189.3L139.8 201.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 173.1C141.3 176.7 144.6 179.2 148.1 180.3L147.7 171.2C143.9 169.6 140.6 165.9 138 160.8L138.5 173.1Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 144.6C140.1 148.2 143.4 150.7 146.9 151.8L146.5 142.7C142.7 141.1 139.4 137.4 136.8 132.3L137.3 144.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4 108.6C142.4 108.2 143.9 108.2 144 110.6C144.1 113 142.4 113.4 140.5 113.7C138.5 114.1 137.1 114.3 137 111.9C136.9 109.5 138.5 109 140.4 108.6Z",
    fill: "#D8D0E7"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.8 150.5H131.4V231.6H171.8V150.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.8 313.5H157.6C143.1 313.5 131.4 301.8 131.4 287.3V231.7H171.8V313.5Z",
    fill: "#3862F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.4 386.5L321 368.1C319.3 367.6 318.3 365.8 318.8 364.1L360 217.3C360.5 215.6 362.3 214.6 364 215.1L429.4 233.4C431.1 233.9 432.1 235.7 431.6 237.4L390.4 384.2C389.8 385.9 388.1 386.9 386.4 386.5Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.4 279.3C412.4 279.3 392.8 274.1 396.2 260.4C399.5 246.7 396.9 244.4 392.7 247.9C388.6 251.4 390.5 255.3 391.9 260.2C393.3 265.1 403.7 280.2 397.2 281.5C390.7 282.9 378.7 271.3 378.1 263.1C377.6 254.9 360.3 258.1 364.5 266.7C368.6 275.3 373.5 285.4 374.9 286.2C376.3 287 396 290.3 396 290.3L412.4 280.1",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.3 382.6L323.8 365.4C322.5 365 321.8 363.7 322.2 362.5L346.7 275L417.7 275.6L388.2 381C387.9 382.2 386.6 382.9 385.3 382.6Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6 292.4L352.7 285.4C350.6 283.3 350.6 279.8 352.8 277.7L359.8 270.8C361.9 268.7 365.4 268.7 367.5 270.9L374.4 277.9C376.5 280 376.5 283.5 374.3 285.6L367.3 292.5C365.1 294.6 361.7 294.6 359.6 292.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6 284L388.4 288.2C385.9 289.5 382.8 288.5 381.6 286L377.4 277.8C376.1 275.3 377.1 272.2 379.6 271L387.8 266.8C390.3 265.5 393.4 266.5 394.6 269L398.8 277.2C400.1 279.7 399.1 282.7 396.6 284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1 332.3C392.4 331.8 391.4 330.1 391.9 328.4L415.2 245.3C415.7 243.6 417.4 242.6 419.1 243.1C420.8 243.6 421.8 245.3 421.3 247L398 330.1C397.5 331.8 395.8 332.8 394.1 332.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.4 309.1C363.769 309.1 366.5 306.369 366.5 303C366.5 299.631 363.769 296.9 360.4 296.9C357.031 296.9 354.3 299.631 354.3 303C354.3 306.369 357.031 309.1 360.4 309.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.3 335.6C375.785 335.6 377.8 333.585 377.8 331.1C377.8 328.615 375.785 326.6 373.3 326.6C370.815 326.6 368.8 328.615 368.8 331.1C368.8 333.585 370.815 335.6 373.3 335.6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.4 319.5C385.885 319.5 387.9 317.485 387.9 315C387.9 312.515 385.885 310.5 383.4 310.5C380.915 310.5 378.9 312.515 378.9 315C378.9 317.485 380.915 319.5 383.4 319.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.3 342.1C346.785 342.1 348.8 340.085 348.8 337.6C348.8 335.115 346.785 333.1 344.3 333.1C341.815 333.1 339.8 335.115 339.8 337.6C339.8 340.085 341.815 342.1 344.3 342.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.2 305.6L344.4 290.8C343.9 290.7 343.6 290.2 343.8 289.7L347.9 275L406.5 275.6L398.3 305C398.1 305.4 397.6 305.7 397.2 305.6Z",
    fill: "#EA662B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 266.2L216.2 177.1H314.8L265.5 266.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.7 256.3H262.3V379.7H268.7V256.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5 392.1C287.315 392.1 305 386.683 305 380C305 373.317 287.315 367.9 265.5 367.9C243.685 367.9 226 373.317 226 380C226 386.683 243.685 392.1 265.5 392.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9 195.1L265.5 252.6L232.9 194.6",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.8 151C243.052 151 246.5 147.553 246.5 143.3C246.5 139.047 243.052 135.6 238.8 135.6C234.547 135.6 231.1 139.047 231.1 143.3C231.1 147.553 234.547 151 238.8 151Z",
    fill: "#283897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.322 141.372L237.414 142.11L258.866 226.633L261.773 225.895L240.322 141.372Z",
    fill: "#283897"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.9 195.1L265.5 252.6L232.9 194.6",
    fill: "#BB0000"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270 177.1H236.5V194.6H270V177.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 205.9C286.2 205.3 285.9 204.1 286.4 203.1L297.4 184C298 183 299.2 182.7 300.2 183.2C301.2 183.8 301.5 185 301 186L290 205.1C289.4 206.1 288.2 206.5 287.2 205.9Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1 301.7C78.5 323.1 101.8 331.5 120.3 334.9C140.9 338.6 162.2 338.6 183.2 337.5C225.4 334.9 267.8 327.5 308.8 317.1C325.5 313.4 331.9 337.1 315.3 342.2C258.3 352.5 134.5 366.4 86.6 332.3C76.9 325.5 69.8 314.4 69.5 302.3C69.4 297.9 75.6 297.4 76.1 301.7Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_302056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/Drink.f3751bc8.svg";
export { ForwardRef as ReactComponent };